const getEnvironmentConfig = async () => {
  // Defaults to local, not dev. Nothing sets VITE_APP_ENV on a developer's machine --
  // `npm run dev` is bare `vite` -- so the default is what every local run gets, and
  // defaulting to the dev ENVIRONMENT pointed those runs at remote dev-server URLs.
  // A deployment sets VITE_APP_ENV explicitly; a laptop should not have to.
  const env = import.meta.env.VITE_APP_ENV || 'local';
  
  switch (env) {
    case 'local':
      return (await import('./env.local.js')).default;
    case 'qa':
      return (await import('./env.qa.js')).default;
    case 'prod':
      return (await import('./env.prod.js')).default;
    default:
      return (await import('./env.dev.js')).default;
  }
};

const config = await getEnvironmentConfig();

// WHERE THE API IS, FROM THE BUILD AND NOT FROM THE PAGE.
//
// The per-environment files above say API_BASE_URL is empty, which every consumer reads as "this origin".
// That is right for a machine whose dev server proxies /api, and wrong for DEV, QA and PROD: there the
// client is served from one host and the API lives on another (VITE_API_BASE_URL -- agent.xtremand.com for
// DEV). A request to the page's own host is answered by the web server's SPA fallback, which returns
// index.html with a 200, so a screen asking for JSON is handed the whole page and nothing says why.
//
// So when the build names an API host, the ported code uses it, exactly as the code written here already does.
// Empty (every local run) leaves the files above as they were.
const apiBase = import.meta.env.VITE_API_BASE_URL;

export default apiBase ? { ...config, API_BASE_URL: apiBase } : config;